import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals.ts';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'weather-icons/css/weather-icons.css';
import './index.css';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);

  // reportWebVitals(console.log);
  reportWebVitals();
}
